import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError, EMPTY } from 'rxjs';
import { LoginService } from '../service/login.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private readonly loginService = inject(LoginService);

  private readonly handleUnauthorizedAccess = () => {
    this.loginService.permissionFailedLogout();
    window.location.reload();
    return EMPTY;
  };

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((response, _) => {
        if (!(response instanceof HttpErrorResponse)) {
          return throwError(() => response);
        }
        if (response.status === 401) {
          return this.handleUnauthorizedAccess();
        }
        return throwError(() => response);
      })
    );
  }
}
